import { WalletAdd1 } from "iconsax-reactjs"
import { Eye, EyeClosed } from "lucide-react"
import { parseAsBoolean, useQueryState } from "nuqs"

import { HiddenBalanceIcon } from "@/components/shared"
import { Button } from "@/components/ui"
import { useCurrentUser, useShowBalance } from "@/modules/helpers/hooks/shared"
import { sendHaptic } from "@/modules/helpers/utils"

type BillingBalanceCardProps = {
  balance: number
  onWithdraw: () => void
}

export const HiddenBalance = () => {
  return <HiddenBalanceIcon />
}

export function BillingBalanceCard({ balance, onWithdraw }: BillingBalanceCardProps) {
  const { showBalance, setShowBalance } = useShowBalance()
  const [_, setPopupPhoneCheck] = useQueryState(
    "popup_phone_check",
    parseAsBoolean.withDefault(false)
  )
  const { user } = useCurrentUser()
  const formatBalance = (amount: number) => {
    if (!showBalance) return "*****"
    return Number(amount).toLocaleString()
  }

  const onToggleBalance = () => {
    setShowBalance(!showBalance)
  }

  return (
    <>
      <div
        data-testid="balance-card"
        className="p-4 rounded-2xl bg-background py-2 flex justify-between items-center relative z-10 w-full"
      >
        <div className="flex items-center gap-2 justify-between w-full">
          <div className="flex gap-2 flex-col">
            <p className="text-gray-500 text-xs font-light">Số dư khả dụng</p>
            <div className="flex items-center gap-2">
              {showBalance ? (
                <p className="text-sm font-semibold text-gradient-primary">
                  {formatBalance(balance)} ₫
                </p>
              ) : (
                <HiddenBalance />
              )}
              {showBalance ? (
                <Eye size={16} color="#0091AA" onClick={onToggleBalance} />
              ) : (
                <EyeClosed size={16} color="#0091AA" onClick={onToggleBalance} />
              )}
            </div>
          </div>
          <Button
            onClick={() => {
              if (!user?.phoneNumber) {
                setPopupPhoneCheck(true)
                return
              }
              onWithdraw()
              sendHaptic()
            }}
            className="flex items-center  gap-2 h-7 bg-primary-50 rounded-full"
          >
            <WalletAdd1 size={16} color="#0091AA" />
            <span className="text-xs font-normal text-primary">Rút tiền</span>
          </Button>
        </div>
      </div>
    </>
  )
}
